import { useState } from "react"

export const usePagination = (initialPage, initialPageSize, initialTotalItems) => {
  const initialPagination = {
    first: initialPageSize || 0,
    skip: (initialPage - 1) * initialPageSize || 0
  }

  const [currentPage, setCurrentPage] = useState(initialPage || 1)
  const [totalPages, setTotalPages] = useState(
    initialPageSize > 0
      ? Math.ceil(initialTotalItems / initialPageSize)
      : 1
  )
  const [totalItems, setTotalItems] = useState(initialTotalItems || 0)
  const [pagination, setPagination] = useState(initialPagination)

  const changePagination = (page, pageSize) => {
    setCurrentPage(page)
    setPagination({
      first: pageSize,
      skip: (page - 1) * pageSize
    })
  }

  const changeTotalItems = newTotalItems => {
    setTotalItems(newTotalItems)
    setTotalPages(pagination.first > 0 ? Math.ceil(newTotalItems / pagination.first) : 1)
  }

  const setInitialPagination = () => {
    setCurrentPage(initialPage || 1)
    setPagination(initialPagination)
  }

  return ({
    totalItems,
    totalPages,
    currentPage,
    changePagination,
    changeTotalItems,
    setInitialPagination,
    skip: pagination.skip,
    first: pagination.first
  })
}